export default __webpack_public_path__ + "c504db5c06caaf7cdfbab9c137d2f314.woff2";